import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/dengru',
    name: 'dengru',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/dengru.vue'),
    meta: {
      title: '登入'
    }
  },{
    path: '/zhuye',
    name: 'zhuye',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/zhuye.vue'),
    meta: {
      title: 'Revit管理页面'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next)=>{

  if (to.path === '/dengru'){
    next();
  }else {
    if (window.localStorage.getItem("dengru")){
      next();
    }else {
      next('/dengru')
    }
  }

});

export default router
